import { makeVerification } from './makeVerification';
export const verifyEdit = makeVerification('edit_activities');
